import React, { useContext, useState, useEffect } from "react";
import { CartContext } from "../context/CartContext";
import { ProductContext } from "../context/ProductContext";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoginContext } from "../context/LoginContext";
import {
  faShoppingCart,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./css/Products.css";

const Cart = (props) => {
  const cartItem = useContext(CartContext);

  const [productItem, setProductItem] = useContext(ProductContext);

  const [show, setShow] = useState(false);

  const [showResult, setShowResult] = useState(false);

  const [showChange, setShowChange] = useState(false);

  const [vazniInput, setVazniInput] = useState("");

  const [vaznInfoInput, setVaznInfoInput] = useState("");

  const [tedadiInput, setTedadiInut] = useState("");

  const [isVazni, setIsVazni] = useState();

  const [changePk, setChangePk] = useState(0);

  const [result, setResult] = useState({ result: false, message: "" });

  const [isLoading, setIsLoading] = useState(false);

  const loginContext = useContext(LoginContext);

  useEffect(() => {
    if (!loginContext.loginState) {
      cartItem.setItems([]);
    }
  }, [loginContext.loginState]);

  useEffect(() => {
    if (cartItem.isQuick) {
      setShow(true);
    }
  }, [cartItem.isQuick]);

  const showModal = () => {
    setShow(true);
  };

  const changeBtn = (pk) => {
    const array = [...cartItem.items];
    const index = array.findIndex((item) => {
      return item.product.pk === pk;
    });
    const item = array[index];
    if (item.type === "vazni") {
      setIsVazni(true);
      setVazniInput(item.value.split("#")[0]);
      setVaznInfoInput(item.value.split("#")[1]);
    } else if (item.type === "tedadi") {
      setIsVazni(false);
      setTedadiInut(item.value.split("#")[1]);
    }
    setChangePk(pk);
    setShowChange(true);
  };

  const delItem = (pk) => {
    const array = [...cartItem.items];
    const index = array.findIndex((item) => {
      return item.product.pk === pk;
    });
    array.splice(index, 1);
    cartItem.setItems(array);
    if (array.length === 0) {
      setShow(false);
    }
  };

  const Vazn = (props) => (
    <div>
      <p className="card-text">وزن : {props.vazn.split("#")[0]} گرم</p>
      {props.vazn.split("#")[1] !== "" ? (
        <p className="card-text">توضیحات : {props.vazn.split("#")[1]} </p>
      ) : null}
    </div>
  );

  const Tedad = (props) => {
    return (
      <table className="table table-sm rtl">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">تعداد</th>
            <th scope="col">قیمت</th>
            <th scope="col">توضیحات</th>
          </tr>
        </thead>
        <tbody>
          {props.value.split("@").map((val, index) => (
            <tr key={index}>
              <th scope="row">{index + 1}</th>
              <td>{val.split("#")[0].split("~")[0]}</td>
              <td>{props.price}</td>
              <td>{val.split("#")[1]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  };

  const pardakht = () => {
    sabt();
    let amount = 0;
    const arr = cartItem.items.map((item) => {
      const val = parseFloat(item.product.finalAmount.replaceAll(",", ""));
      amount += val;
    })
    const link = `https://z64.ir/zarinpal/api/data/purchase.php?vitrinCode=${props.id}&amount=${amount}`;
    window.open(link, '_blank').focus();
  }

  const sabt = () => {
    setIsLoading(true);
    const vazni = cartItem.items.filter((item) => {
      return item.type === "vazni";
    });
    const tedadi = cartItem.items.filter((item) => {
      return item.type === "tedadi";
    });

    const vaznArray = [];
    const vaznId = [];
    const tedadArray = [];
    const tedadId = [];
    const tedadPrice = [];
    const vaznPrice = [];
    let vitrinId = 0,
      visitorId = 0;

    for (let i = 0; i < vazni.length; i++) {
      vaznArray.push(vazni[i].value);
      vaznId.push(vazni[i].product.pk);
      const productPrice = productItem.find(
        (item) => item.pk === vazni[i].product.pk
      );
      vaznPrice.push(productPrice.finalAmount);
    }

    for (let i = 0; i < tedadi.length; i++) {
      tedadArray.push(tedadi[i].value);
      tedadId.push(tedadi[i].product.pk);
      const productPrice = productItem.find(
        (item) => item.pk === tedadi[i].product.pk
      );
      tedadPrice.push(productPrice.finalAmount);
    }

    if (props.isVisitor === 1) {
      visitorId = props.id;
    } else {
      vitrinId = props.id;
    }

    const formData = new FormData();
    formData.append("save_sefaresh_mokamel_mobile", 1);
    // formData.append("test", 1);
    formData.append("vazn_id", vaznId);
    formData.append("vazn_array", vaznArray);
    formData.append("tedad_id", tedadId);
    formData.append("tedad_array", tedadArray);
    formData.append("name_kharidar", loginContext.userInfo.name);
    formData.append("mobile_kharidar", loginContext.userInfo.mobile);
    formData.append("vitrin_id", vitrinId);
    formData.append("visitor_id", visitorId);
    formData.append("vaznPrice", JSON.stringify(vaznPrice));
    formData.append("tedadPrice", JSON.stringify(tedadPrice));

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result === true) {
          setResult({ result: data.result, message: data.message });
          setIsLoading(false);
          setShow(false);
        } else {
          setIsLoading(false);
          setShow(false);
          setResult({
            result: data.result,
            message: "فرآیند با اشکال موجه شد",
          });
        }
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
        setShow(false);
        setResult({
          result: false,
          message: "فرآیند با اشکال موجه شد",
        });
      });
    setShowResult(true);
  };

  const change = () => {
    const array = [...cartItem.items];
    const index = array.findIndex((item) => {
      return item.product.pk === changePk;
    });
    const item = array[index];
    if (isVazni) {
      if (vazniInput === "") {
        alert("وزن را وارد کنید");
        return;
      } else {
        item.value = vazniInput + "#" + vaznInfoInput;
      }
    } else {
      item.value = item.value.split("#")[0] + "#" + tedadiInput;
    }
    array.splice(index, 1, item);
    cartItem.setItems(array);
    setVazniInput("");
    setVaznInfoInput("");
    setTedadiInut("");
    setShowChange(false);
  };

  const vazniInputHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setVazniInput(e.target.value);
  };

  const vazniInfoInputHandle = (e) => {
    setVaznInfoInput(e.target.value);
  };

  const tedadiInputHandle = (e) => {
    setTedadiInut(e.target.value);
  };

  const changeModal = isVazni ? (
    <div className="mt-3">
      <h6>وزن</h6>
      <input
        type="text"
        inputMode="numeric"
        maxLength="11"
        className="form-control rtl"
        placeholder="وزن"
        value={vazniInput}
        onChange={vazniInputHandle}
      ></input>
      <h6>توضیحات</h6>
      <textarea
        value={vaznInfoInput}
        onChange={vazniInfoInputHandle}
        className="form-control"
      ></textarea>
    </div>
  ) : (
    <div className="mt-3">
      <h6>توضیحات</h6>
      <textarea
        value={tedadiInput}
        onChange={tedadiInputHandle}
        className="form-control"
      ></textarea>
    </div>
  );

  if (cartItem.items.length > 0) {
    return (
      <div>
        <button className="btn btn-dark cartBtn" onClick={showModal}>
          <FontAwesomeIcon icon={faShoppingCart} /> {cartItem.items.length}
        </button>
        <div>
          <Modal
            show={show}
            onHide={() => {
              setShow(false);
              cartItem.setIsQuick(false);
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header className="rtl">
              <h2>
                <FontAwesomeIcon icon={faShoppingCart} />
                سبد خرید
              </h2>
            </Modal.Header>
            <Modal.Body className="rtl">
              {cartItem.items.map((item) => (
                <div key={item.product.pk} className="card mb-3">
                  <div className="row no-gutters">
                    <div className="col-md-4">
                      <img
                        src={item.product.img_1}
                        className="card-img"
                        alt="..."
                      />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="card-title">{item.product.kalaName}</h5>
                        {item.type === "vazni" ? (
                          <Vazn vazn={item.value} />
                        ) : (
                          <Tedad value={item.value} price={item.product.finalAmount} />
                        )}
                        <button
                          className="btn btn-outline-success ml-2"
                          onClick={() => {
                            changeBtn(item.product.pk);
                          }}
                        >
                          ویرایش
                        </button>
                        <button
                          className="btn btn-outline-danger"
                          onClick={() => {
                            delItem(item.product.pk);
                          }}
                        >
                          حذف
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary" onClick={sabt}>
                ارسال سفارش
              </button>
              <button className="btn btn-primary" onClick={pardakht}>
                پرداخت
              </button>
              <button
                className="btn btn-dark"
                onClick={() => {
                  setShow(false);
                  cartItem.setIsQuick(false);
                }}
              >
                بستن
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showResult}
            onHide={() => {
              setShowResult(false);
              if (result.result === true) {
                cartItem.setItems([]);
              }
            }}
            backdrop="static"
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header className="rtl">
              <FontAwesomeIcon icon={faInfoCircle} size="2x" />
            </Modal.Header>
            <Modal.Body>
              {!isLoading ? (
                <div>{result.message}</div>
              ) : (
                <div className="row justify-content-center m-5 p-5">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              {!isLoading ? (
                <button
                  className="btn btn-dark"
                  onClick={() => {
                    setShowResult(false);
                    if (result.result === true) {
                      cartItem.setItems([]);
                    }
                  }}
                >
                  بستن
                </button>
              ) : null}
            </Modal.Footer>
          </Modal>

          <Modal
            className="rtl"
            show={showChange}
            onHide={() => {
              setShowChange(false);
            }}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header className="rtl">ویرایش</Modal.Header>
            <Modal.Body>{changeModal}</Modal.Body>
            <Modal.Footer className="rtl">
              <button className="btn btn-success ml-2" onClick={change}>
                ثبت
              </button>
              <button
                className="btn btn-dark"
                onClick={() => {
                  setShowChange(false);
                }}
              >
                بستن
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default Cart;
